import React, { useEffect, useState } from "react";
import IngredientLogo from "../../Asset/ingredient logo.png";
import "react-confirm-alert/src/react-confirm-alert.css";
import { toast } from "react-toastify";
import { confirmAlert } from "react-confirm-alert";
import { sidebarSections } from "../Items/Items";
import Navbar from "../../component/Navbar/Navbar";
import Sidebar from "../../component/sidebar/Sidebar";
import { MdDelete } from "react-icons/md";
import CreateIngredient from "../../component/CreateIngredient/CreateIngredient";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteIngredient,
  getIngredients,
  selectIngredients,
} from "../../redux/features/ingredient/IngredientSlice";
import EditIngredient from "../../component/EditIngredient/EditIngredient";
import {
  filterIngredients,
  selectFilteredIngredients,
} from "../../redux/features/filter/FilterSlice";
import ReactPaginate from "react-paginate";
import "../Items/Items.css";
import PreviewIngredient from "./PreviewIngredient";

const Ingredient = () => {
  const dispatch = useDispatch();
  const [search, setSearch] = useState("");
  const ingredients = useSelector(selectIngredients);
  const filteredIngredients = useSelector(selectFilteredIngredients);

  const confirmDelete = (id, name) => {
    if (!id || !name) {
      toast.error("ID or Name is undefined");
      return;
    }
    confirmAlert({
      title: "Delete This Ingredient",
      message: `Are you sure to delete this ${name}?`,
      buttons: [
        {
          label: "Delete",
          onClick: () => removeIngregient(id),
        },
        {
          label: "Cancel",
        },
      ],
    });
  };
  const removeIngregient = async (id) => {
    await dispatch(deleteIngredient(id));
    dispatch(getIngredients());
  };

  useEffect(() => {
    dispatch(getIngredients());
  }, [dispatch]);

  // start pagination
  const itemsPerPage = 10;
  const [itemOffset, setItemOffset] = useState(0);
  const endOffset = itemOffset + itemsPerPage;
  const currentIngredients = filteredIngredients?.slice(itemOffset, endOffset);
  const pageCount = Math.ceil(filteredIngredients?.length / itemsPerPage);

  // Invoke when user click to request another page.
  const handlePageClick = (event) => {
    const newOffset =
      (event.selected * itemsPerPage) % filteredIngredients?.length;

    setItemOffset(newOffset);
  };
  // end pagination

  useEffect(() => {
    dispatch(filterIngredients({ search, ingredients }));
  }, [dispatch, search, ingredients]);

  const sidebarSection = sidebarSections;
  return (
    <div className="flex flex-col h-screen bg-[#F1F1F1]">
      {/* Navbar */}

      <Navbar page="Ingredients" />

      <div className="flex flex-1 overflow-hidden">
        {/* Sidebar */}
        <div className="md:w-[30%] w-[35%] bg-white shadow-md">
          <Sidebar sidebarSections={sidebarSection} />
        </div>

        {/* Main Content */}
        <div className="flex-1 flex  justify-center p-8 overflow-y-auto">
          <div className=" flex flex-col w-full ">
            <div className="flex lg:justify-end justify-start my-4 items-center ">
              <input
                type="search"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                className="bg-transparent py-2 px-4 border-2 border-[#A9A9A9]  rounded-full outline-none"
                placeholder="Search by name..."
              />
            </div>

            {currentIngredients?.length > 0 ? (
              <>
                <div className="md:w-full w-[32rem] mx-auto md:mb-10 mb-5 ">
                  <div className="lg:space-y-4 space-y-2">
                    <div
                      className={`flex items-center justify-between  pb-0 w-full font-bold capitalize lg:text-[1rem] text-[.8rem] `}
                    >
                      <div className="flex items-center  lg:w-[60%] w-[50%]">
                        <span className="w-[20%] ">Sr #</span>

                        <span className=" w-[80%]  ">name</span>
                      </div>

                      <div className="flex items-center lg:w-[40%] w-[50%]">
                        <div className=" w-[50%]">Inventory</div>

                        <div className="w-[50%]">Action</div>
                      </div>
                    </div>
                    {currentIngredients?.map((item, index) => {
                      return (
                        <div
                          key={item?._id}
                          className={`flex items-center justify-between lg:pt-4 pt-2 pb-0 border-t-2 border-[#DEDEDE]
                        }`}
                        >
                          <div className="flex items-center lg:w-[60%] w-[50%]">
                            <span className="w-[20%] lg:text-[1rem] text-[.8rem]">
                              {index + 1}
                            </span>

                            <span className="font-inter-600 lg:text-[1rem] text-[.8rem] w-[80%] text-wrap capitalize text-[#0D868C]">
                              {item?.name}
                            </span>
                          </div>

                          <div className="flex items-center lg:w-[40%] w-[50%]">
                            <span
                              title={`${item?.quantity?.toFixed(0)} ${
                                item.inventoryUnit
                              }`}
                              className={`${
                                item.quantity < 0
                                  ? "text-[#ad3a3a]"
                                  : "text-[#1E1E1E]"
                              }  lg:text-[1rem] text-[.8rem] font-inter-400 w-[50%]  `}
                            >
                              {(item?.quantity / item?.conversionRate).toFixed(
                                2
                              )}{" "}
                              {item?.purchaseUnit}
                            </span>

                            <div className="flex items-center w-[50%] lg:gap-3 gap-1.5">
                              <PreviewIngredient
                                trackHistory={item?.trackHistory}
                              />
                              <EditIngredient id={item._id} />
                              <span
                                onClick={() =>
                                  confirmDelete(item._id, item?.name)
                                }
                                className="bg-[#f1524d] text-center text-white p-1 rounded-lg cursor-pointer"
                              >
                                <MdDelete className="lg:size-6 size-5" />
                              </span>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                  {filteredIngredients?.length > itemsPerPage && (
                    <ReactPaginate
                      breakLabel="..."
                      nextLabel="Next"
                      onPageChange={handlePageClick}
                      pageRangeDisplayed={2}
                      pageCount={pageCount}
                      previousLabel="Prev"
                      renderOnZeroPageCount={null}
                      containerClassName="pagination"
                      pageLinkClassName="page-num"
                      previousLinkClassName="page-num"
                      nextLinkClassName="page-num"
                      activeLinkClassName="activePage"
                    />
                  )}
                </div>
                <CreateIngredient />
              </>
            ) : (
              <div className="flex items-center justify-center md:w-full w-[27rem]">
                <div className="md:w-[30rem] w-[25rem] lg:w-[38rem]  relative  lg:h-[30rem] h-[23rem] bg-[#A9A9A9] rounded-[2.4rem] text-white flex flex-col justify-center items-center ">
                  <img
                    src={IngredientLogo}
                    className="size-16 md:size-36 mb-2"
                    alt="Logo"
                  />

                  <p className="text-[1rem] md:text-[1.5rem] font-inter-700 text-center">
                    You have no ingredient yet
                  </p>
                  <p className="text-[.8rem] md:text-[1rem] font-inter-400 text-center">
                    To add a ingredient, press the (+) button
                  </p>
                  <CreateIngredient />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Ingredient;
